import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

export interface AdminAccessLogRecord {
	_id: string
	managerId: string
	email: string
	actionEvent: 'ADMIN_ACCESS_SESSION'
	createdAt: string
	updatedAt: string
	payload: {
		status: 'CREATED' | 'CONSUMED' | 'EXPIRED' | 'REVOKED'
		sessionId: string
		clientId: string
		adminId: string
		targetEmail?: string | null
		targetName?: string | null
		isAdminAccount?: boolean
		reason: string
		expiresAt: number
		consumedAt?: number | null
		sourceIp?: string | null
		userAgent?: string | null
	}
}

interface PaginatedResponse {
	records: AdminAccessLogRecord[]
	totalCount: number
	totalPages: number
	currentPage: number
	page: number
	size: number
}

const getClientAdminAccessSessions = async (
	clientId: string,
	page = 1,
	size = 10
): Promise<PaginatedResponse> => {
	try {
		const { data } = await axios.get<PaginatedResponse>(
			`management/client/${clientId}/admin-access/session`,
			{ params: { page, size } }
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getClientAdminAccessSessions
